import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { PublicClassNames } from 'embed/constants'
import { getContrastingColor } from 'embed/utils'

import { TrustedPartnerContainer } from 'embed/components/TrustedPartners/container'
import { css } from 'emotion'
import * as React from 'react'

import { TrustedPartner } from 'embed/components/TrustedPartners'
import { FeatureFlag, TrustedPartnersSectionLocation } from 'even-ts-static'

const applicationStyles = require('embed/styles/application')
const styles = require('./styles.scss')

export interface CreditCardIntroProps {
  bullets?: JSX.Element[]
  featureFlags?: FeatureFlag[]
  header?: string
  onContinue: () => void
  showTrustedPartners?: TrustedPartnersSectionLocation
  staticTrustedPartners?: TrustedPartner[]
}

export const CreditCardIntro: React.FC<CreditCardIntroProps> = ({
  bullets,
  featureFlags = [],
  header,
  onContinue,
  showTrustedPartners,
  staticTrustedPartners,
}) => {
  const useDynamicTrustedPartners =
    showTrustedPartners === TrustedPartnersSectionLocation.Embed &&
    featureFlags?.includes(FeatureFlag.DynamicTrustedPartners)

  const useStaticTrustedPartners =
    showTrustedPartners === TrustedPartnersSectionLocation.Embed &&
    !featureFlags.includes(FeatureFlag.DynamicTrustedPartners)

  return (
    <ThemeConsumer>
      {({
        backdropStyles,
        borderRadiusSmall,
        boxStyles,
        colorBorder,
        ctaStyles,
        colorTextPrimary,
        fontFamilyPrimary,
      }) => (
        <div className={styles.wrapper}>
          <div
            className={classnames(
              PublicClassNames.ApplicationContainer,
              styles.container,
              css`
                background-color: ${backdropStyles.backgroundColor};
                border-style: solid;
                border-width: 1px;
                border-color: ${colorBorder};
                border-radius: ${borderRadiusSmall};
                font-family: ${fontFamilyPrimary};
                font-color: ${colorTextPrimary};
                padding: 20px;
              `,
            )}
            style={boxStyles}
          >
            <div className={classnames(styles.content)}>
              <div className={classnames(styles.header)}>
                <h2
                  className={classnames(css`
                    font-family: ${fontFamilyPrimary};
                    color: ${colorTextPrimary};
                  `)}
                >
                  {header}
                </h2>
              </div>
              <div className={classnames(styles.bulletContainer)}>
                {bullets &&
                  bullets.map((bullet, index) => (
                    <div key={index} className={classnames(styles.iconInfo)}>
                      {bullet}
                    </div>
                  ))}
              </div>
              <div className={styles.introFooter}>
                <div className={styles.getStarted}>
                  <button
                    className={classnames(
                      styles.button,
                      css`
                        color: ${getContrastingColor(ctaStyles?.backgroundColor, { black: colorTextPrimary })};
                        border-radius: ${borderRadiusSmall};
                      `,
                    )}
                    style={ctaStyles}
                    onClick={onContinue}
                  >
                    Get Started
                  </button>
                </div>
                <div className={classnames(styles.disclaimer)} data-test-id="disclaimer">
                  This service is free and will NOT affect your credit score
                </div>
              </div>
              {useDynamicTrustedPartners && <TrustedPartnerContainer />}
              {useStaticTrustedPartners && <TrustedPartnerContainer staticTrustedPartners={staticTrustedPartners} />}
            </div>
          </div>
        </div>
      )}
    </ThemeConsumer>
  )
}
